import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// SECURITY: User-bound thread state structure
export interface UserThreadState {
  threadId: string | null;
  ownerUserId: string | null;
  ownerRole: string | null;
}

export interface assistantState {
  assistant: String;
  // SECURITY: Store threadId per user to prevent cross-user leakage
  threadsByUser: {
    [userId: string]: UserThreadState;
  };
  // Legacy support - will be deprecated
  threadId: String;
}

const initialState: assistantState = {
  assistant: "",
  threadsByUser: {},
  threadId: "",
};

export const assistantSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateAssistant: (state, action: PayloadAction<any>) => {
      state.assistant = action.payload;
    },
    // SECURITY: Update threadId with user binding
    updateThreadId: (state, action: PayloadAction<{ threadId: any; userId?: string; userRole?: string }>) => {
      const { threadId, userId, userRole } = action.payload;
      
      // Legacy support
      state.threadId = threadId;
      
      // SECURITY: Store thread per user
      if (userId) {
        if (!state.threadsByUser[userId]) {
          state.threadsByUser[userId] = {
            threadId: null,
            ownerUserId: null,
            ownerRole: null,
          };
        }
        state.threadsByUser[userId].threadId = threadId;
        state.threadsByUser[userId].ownerUserId = userId;
        state.threadsByUser[userId].ownerRole = userRole || null;
      }
    },
    // SECURITY: Clear thread for specific user (on logout)
    clearUserThread: (state, action: PayloadAction<{ userId: string }>) => {
      const { userId } = action.payload;
      delete state.threadsByUser[userId];
      
      // Clear legacy threadId if it belonged to this user
      const userThread = state.threadsByUser[userId];
      if (userThread && state.threadId === userThread.threadId) {
        state.threadId = "";
      }
    },
    // SECURITY: Clear all threads (on global logout)
    clearAllThreads: (state) => {
      state.threadsByUser = {};
      state.threadId = "";
    },
  },
});
export const { updateAssistant, updateThreadId, clearUserThread, clearAllThreads } = assistantSlice.actions;

export default assistantSlice.reducer;
